import { useEffect, useState } from 'react';
import { changeFaviconByTheme } from '../utils/faviconUtils';
import { changeFavicon } from '../utils/changeFavicon';
import graphqlRequest from '../requestMethod';
import { set } from 'date-fns';

/**
 * Custom hook to manage theme-based favicon changes
 * @returns {Object} - Theme state and setter function
 */
const useThemeFavicon = () => {
  const [currentTheme, setCurrentTheme] = useState('Default');

  
  // Fetch theme from backend when component mounts
  useEffect(() => {
    const fetchTheme = async () => {
       
      try {
            const query = `
                  query {
                  getActiveIcon {
                  _id
                  iconName
                  platform
                  isActive
                  }
                  }`;
            graphqlRequest(query).then((response) => {
              console.log("response", response.data.getActiveIcon);
              if(response.data.getActiveIcon.isActive  && ( response.data.getActiveIcon.platform === "webApp" || response.data.getActiveIcon.platform === "both" )) {
              setCurrentTheme(response.data.getActiveIcon.iconName);
              changeFavicon(response.data.getActiveIcon.iconName);
              changeFaviconByTheme(response.data.getActiveIcon.iconName);
              } else {
                changeFaviconByTheme('Default');
                setCurrentTheme('Default');
                changeFavicon('Default');
              }
            });
      } catch (error) {
        console.error('Failed to fetch theme:', error);
        // Fallback to default theme on error
        changeFaviconByTheme('Default');
      }
    };

    fetchTheme();
  }, []);

  // Update favicon when theme changes
  useEffect(() => {
    changeFaviconByTheme(currentTheme);
  }, [currentTheme]);

  return { currentTheme, setCurrentTheme };
};

export default useThemeFavicon;
